export default "__VITE_ASSET__BoDZW2p8__"